import PropTypes from "prop-types";
import ParticleTwo from "../../particles/ParticleTwo";
import { Link } from "react-router-dom";
const BreadcrumbDepositsAndWithdrawals = () => {
  return (
    <div
      className="ht__bradcaump__area_market"
      style={{
        background: `rgba(0, 0, 0, 0) url(${
          process.env.PUBLIC_URL + "/images/about/bull_right_side.jpg"
        }) repeat scroll center center/105% 100%`,
      }}
    >
      <div className="ht__bradcaump__container_market">
        <div className="container">
          <div className="row">
            <div className="col-lg-9">
              <h1>Fast. Secure. Built for Traders Who Move Quickly.</h1>
              <p>
                At The Pips, your money moves as fast as your trades. We process
                99% of withdrawals within 24 hours, and in many cases, even
                faster, because your capital should never slow you down
              </p>
              <Link
                className="slide__btn dg__btn"
                to={process.env.PUBLIC_URL + "/register"}
              >
                Register
              </Link>
              {/* Small invisible element acting as a spacer */}
              <span style={{ marginRight: "15px" }}></span>
              <Link
                className="slide__btn dg__btn"
                to={process.env.PUBLIC_URL + "/company/contact"}
              >
                Try free demo
              </Link>
            </div>
          </div>
        </div>
      </div>
      {/* <ParticleTwo /> */}
    </div>
  );
};

BreadcrumbDepositsAndWithdrawals.propTypes = {
  title: PropTypes.string,
};

export default BreadcrumbDepositsAndWithdrawals;
